const guestExactPaths = new Set(['/', '/recruitments', '/forums', '/help']);

export function isGuestReadablePath(pathname: string): boolean {
  const normalized = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;

  if (guestExactPaths.has(normalized)) return true;
  if (/^\/forums\/board\/[^/]+$/.test(normalized)) return true;
  if (/^\/forums\/(?!new$)[^/]+$/.test(normalized)) return true;
  if (/^\/archives\/characters\/\d+$/.test(normalized)) return true;
  return /^\/archives\/rooms\/[^/]+\/report$/.test(normalized);
}

export function shouldHandleUnauthorized(status: number, token: string | null): boolean {
  return status === 401 && Boolean(token);
}
